export default __webpack_public_path__ + "static/media/4.38163b6a.jpg";